export function sortColumn(item: string, filter: any) {
  if (item === filter.sort_field) {
    switch (filter.sort_mode) {
      case 'asc':
        filter.sort_mode = 'desc'
        break;
      case 'desc':
        filter.sort_mode = 'asc'
        break;
    }
  } else {
    filter.sort_field = item
    filter.sort_mode = 'asc'
  }
}

export function paginationRow(index: number, limits: {min: number, max: number}): string {
  if (limits.min <= index && index < limits.max) {
    if ((index + 1) % 2 !== 0) {
      return 'odd'
    } else {
      return 'even'
    }
  } else {
    return 'd-none'
  }
}
